export const CONTRACTING_ENTITIES = [
  { value: 1, label: 'Spanidea Systems Pvt. Ltd.', sub: 'India' },
  { value: 0, label: 'Spanidea Systems LLC', sub: 'International' },
];
